import React from 'react';
import Button from '~/components/atom/Button';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { useTimelineContext } from '../../context';

type Props = {
  eventId: string;
  contactId: string;
};

const text = {
  startLfaRequest: 'Start LFA Request',
};

const StartLfaRequestButton: React.FC<Props> = ({ eventId, contactId }) => {
  const { onStartLfaRequest } = useTimelineContext();

  if (!onStartLfaRequest) return null;

  return (
    <JustificationContainer margin={['s']}>
      <Button
        ghost
        size="small"
        label={text.startLfaRequest}
        onClick={() => onStartLfaRequest({ eventId, contactId })}
        dataTestId="start-lfa-request-button"
      />
    </JustificationContainer>
  );
};

export default StartLfaRequestButton;
